import { ApolloError, gql, useMutation } from "@apollo/client";
import { UserRole, WorkerType } from "../generated/graphql";

export interface CrStaffUserInput {
  username: string;
  password: string;
  name?: string | null;
  phone?: string | null;
  role: UserRole;
  workerType?: WorkerType | null;
  linkServiceIds?: number[] | null;
}

export interface CrStaffUserOutput {
  ok: boolean;
  err?: string | null;
  id?: number | null;
}

export interface CrStaffUserMutation {
  crStaffUser: CrStaffUserOutput;
}

export interface CrStaffUserMutationVariables {
  input: CrStaffUserInput;
}

const CR_STAFF_USER_MUTATION = gql`
  mutation crStaffUser($input: CrStaffUserInput!) {
    crStaffUser(input: $input) {
      ok
      err
      id
    }
  }
`;

export const useCrStaffUser = (
  onCompleted?: (data: CrStaffUserMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrStaffUserMutation, CrStaffUserMutationVariables>(
    CR_STAFF_USER_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
